import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { APIV2 } from "services/ApiServiceV2";

export const getOrderSummary = createAsyncThunk("order/getOrderSummary", async (arg, thunkAPI) => {
    return await APIV2(`user/v1/order/summary`, "POST", arg, "JAVA")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const placeOrder = createAsyncThunk("order/placeOrder", async (arg, thunkAPI) => {
    return await APIV2("user/v1/order/payment", "POST", arg, "JAVA")
        .then((res) => {
            return { ...res };
        })
        .catch((err) => {
            return err;
        });
});

export const getOrderHistory = createAsyncThunk("order/getOrderHistory", async (arg, thunkAPI) => {
    return await APIV2(`user/v1/order?userId=${thunkAPI.getState().AuthReducer.userId}`, "GET", {}, "JAVA")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const getOrderDetails = createAsyncThunk("order/getOrderDetails", async (arg, thunkAPI) => {
    return await APIV2(`user/v1/order/details?orderId=${arg?.orderId}`, "GET", {}, "JAVA")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const executePayPalPayment = createAsyncThunk("order/executePayPalPayment", async (arg, thunkAPI) => {
    return await APIV2(
        `user/v1/stripe/paypal/success?paymentId=${arg?.paymentId}&PayerID=${arg?.PayerID}`,
        "GET",
        {},
        "JAVA"
    )
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const executeAuthorizeNet = createAsyncThunk("order/executeAuthorizeNet", async (arg, thunkAPI) => {
    return await APIV2(`user/v1/stripe/authorize/charge/v2`, "POST", arg, "JAVA")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const executeIsPaidAtStore = createAsyncThunk("order/executeIsPaidAtStore", async (arg, thunkAPI) => {
    return await APIV2(`user/v1/stripe/success/instore?orderId=${arg?.orderId}`, "GET", {}, "JAVA")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const getStoreAddresses = createAsyncThunk("order/getStoreAddresses", async (arg, thunkAPI) => {
    return await APIV2(`user/v1/user-profile/address?userId=b932e2c6-7cd1-44aa-b8d8-998cdc4207b2`, "GET", {}, "JAVA")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const getUserAddressList = createAsyncThunk("order/getUserAddressList", async (arg, thunkAPI) => {
    return await APIV2(
        `user/v1/user-profile/address?userId=${arg?.userId || thunkAPI.getState().AuthReducer.userId}`,
        "GET",
        {},
        "JAVA"
    )
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const getAddressListAndUpdateBilling = createAsyncThunk(
    "order/getAddressListAndUpdateBilling",
    async (arg, thunkAPI) => {
        return await APIV2(
            `user/v1/user-profile/address?userId=${arg?.userId || thunkAPI.getState().AuthReducer.userId}`,
            "GET",
            {},
            "JAVA"
        )
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err;
            });
    }
);

export const getAddressListAndUpdateDelivery = createAsyncThunk(
    "order/getAddressListAndUpdateDelivery",
    async (arg, thunkAPI) => {
        return await APIV2(
            `user/v1/user-profile/address?userId=${arg?.userId || thunkAPI.getState().AuthReducer.userId}`,
            "GET",
            {},
            "JAVA"
        )
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err;
            });
    }
);

let initialState = {
    orderSummary: null,
    orderCoupon: null,
    billingAddress: null,
    deliveryAddress: null,
    storeAddressList: [],
    userAddressList: [],
    userAddressListLoading: false,
    couponApplied: "",
};

export const orderSlice = createSlice({
    name: "order",
    initialState,
    reducers: {
        setOrderSummary: (state, action) => {
            state.orderSummary = action.payload;
        },
        setBillingAddress: (state, action) => {
            state.billingAddress = action.payload;
        },
        setDeliveryAddress: (state, action) => {
            state.deliveryAddress = action.payload;
        },
        applyCoupon: (state, action) => {
            state.orderCoupon = action.payload;
            state.couponApplied = action.payload?.code;
        },
        removeCoupon: (state, action) => {
            state.orderCoupon = null;
            state.couponApplied = "";
        },
        resetOrderSlice: (state) => {
            state.orderSummary = initialState.orderSummary;
            state.orderCoupon = initialState.orderCoupon;
            state.billingAddress = initialState.billingAddress;
            state.deliveryAddress = initialState.deliveryAddress;
            state.storeAddressList = initialState.storeAddressList;
            state.userAddressList = initialState.userAddressList;
            state.userAddressListLoading = initialState.userAddressListLoading;
            state.couponApplied = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOrderSummary.pending, (state, action) => {})
            .addCase(getOrderSummary.fulfilled, (state, action) => {
                if ([200].includes(action?.payload?.status)) {
                    state.orderSummary = action.payload?.data;
                    try {
                        if (action?.payload?.coupons && Array.isArray(action?.payload?.coupons) && state.orderCoupon) {
                            let exists = action?.payload?.coupons?.find(
                                (o) => o?.code?.toLowerCase() == state?.orderCoupon?.code?.toLowerCase()
                            );
                            if (exists) {
                                state.orderCoupon = exists;
                            } else {
                                state.orderCoupon = null;
                            }
                        } else {
                            state.orderCoupon = null;
                        }
                    } catch (err) {
                        state.orderCoupon = null;
                    }
                }
            })
            .addCase(getOrderSummary.rejected, (state, action) => {
                console.log("getOrderSummary api error", action?.payload);
            })
            .addCase(getStoreAddresses.pending, (state, action) => {})
            .addCase(getStoreAddresses.fulfilled, (state, action) => {
                if ([200].includes(action.payload?.status)) {
                    state.storeAddressList = Array.isArray(action.payload?.data) ? action.payload?.data : [];
                }
            })
            .addCase(getStoreAddresses.rejected, (state, action) => {
                console.log("getStoreAddresses api error", action?.payload);
            })
            .addCase(getUserAddressList.pending, (state, action) => {
                state.userAddressListLoading = true;
            })
            .addCase(getUserAddressList.fulfilled, (state, action) => {
                state.userAddressListLoading = false;
                if ([200].includes(action.payload?.status)) {
                    state.userAddressList = Array.isArray(action.payload?.data) ? action.payload?.data : [];
                }
            })
            .addCase(getUserAddressList.rejected, (state, action) => {
                state.userAddressListLoading = false;
                console.log("getStoreAddresses api error", action?.payload);
            })
            .addCase(getAddressListAndUpdateBilling.pending, (state, action) => {
                state.userAddressListLoading = true;
            })
            .addCase(getAddressListAndUpdateBilling.fulfilled, (state, action) => {
                state.userAddressListLoading = false;
                if ([200].includes(action.payload?.status)) {
                    state.userAddressList = Array.isArray(action.payload?.data) ? action.payload?.data : [];
                    state.billingAddress = state.userAddressList[0];
                }
            })
            .addCase(getAddressListAndUpdateBilling.rejected, (state, action) => {
                state.userAddressListLoading = false;
                console.log("getAddressListAndUpdateBilling api error", action?.payload);
            })
            .addCase(getAddressListAndUpdateDelivery.pending, (state, action) => {
                state.userAddressListLoading = true;
            })
            .addCase(getAddressListAndUpdateDelivery.fulfilled, (state, action) => {
                state.userAddressListLoading = false;
                if ([200].includes(action.payload?.status)) {
                    state.userAddressList = Array.isArray(action.payload?.data) ? action.payload?.data : [];
                    state.deliveryAddress = state.userAddressList[0];
                }
            })
            .addCase(getAddressListAndUpdateDelivery.rejected, (state, action) => {
                state.userAddressListLoading = false;
                console.log("getAddressListAndUpdateDelivery api error", action?.payload);
            });
    },
});

export const { setOrderSummary, applyCoupon, removeCoupon, setBillingAddress, setDeliveryAddress, resetOrderSlice } =
    orderSlice.actions;

export default orderSlice.reducer;
